// Small inline SVG icon helpers.
//
// These replace raw unicode glyphs (e.g. the "▾" chevron) used as dropdown /
// disclosure affordances. A unicode glyph renders thin, off-baseline, or as
// tofu depending on the platform font; an inline SVG with `currentColor` reads
// crisply in both themes and inherits the surrounding text colour/opacity.

const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * A downward-pointing chevron, sized 1rem square by default and inheriting the
 * current text colour. Pass extra classes for sizing, opacity, or rotation
 * (e.g. `-rotate-90` for a collapsed/closed state).
 *
 * @param {string} [extraClass]
 * @returns {SVGSVGElement}
 */
export function chevronDown(extraClass = '') {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('viewBox', '0 0 16 16');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('class', ('inline-block h-4 w-4 flex-shrink-0 ' + extraClass).trim());

  // geometry-exempt: a three-segment polyline, verifiable by reading it. The
  // ban on hand-authored path data exists because nobody can check a bezier by
  // eye; "down 4, right 4, up 4" is not that. It also has to keep inheriting
  // `currentColor` so it follows the text it sits beside, which the duotone
  // token pair deliberately does not do.
  const path = document.createElementNS(SVG_NS, 'path');
  path.setAttribute('d', 'M4 6l4 4 4-4');
  path.setAttribute('stroke', 'currentColor');
  path.setAttribute('stroke-width', '1.5');
  path.setAttribute('stroke-linecap', 'round');
  path.setAttribute('stroke-linejoin', 'round');
  svg.append(path);

  return svg;
}
